import { render } from "./AddModel.vue?vue&type=template&id=2ab71c6b&ts=true"
import script from "./AddModel.vue?vue&type=script&lang=ts"
export * from "./AddModel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__